/**
 * Normalizes a thrown `callSecureApi` error into the string a saga hands to `action.next`.
 * Nest puts the useful text on `payload.message`; a plain `Error` puts it on `message`.
 *
 * `payload.message` is a STRING ARRAY whenever the backend threw a `ValidationError` (which
 * extends `BadRequestException` and is constructed with an array) — para-node's insurance
 * policy delete answers 400 with `['Insurance policy is in use']`. Without the array branch
 * that reason is dropped and the caller's generic fallback is shown instead.
 */
export function resolveErrorMessage(error: unknown, fallback: string): string {
  const messageCarrier = error as {
    payload?: { message?: string | string[] }
    message?: string
  }

  const payloadMessage = messageCarrier?.payload?.message

  if (typeof payloadMessage === 'string') {
    return payloadMessage
  }

  if (Array.isArray(payloadMessage)) {
    const lines = payloadMessage
      .filter((entry): entry is string => {
        return typeof entry === 'string'
      })
      .map((entry) => {
        return entry.trim()
      })
      .filter((entry) => {
        return entry !== ''
      })

    if (lines.length > 0) {
      return lines.join(', ')
    }
  }

  if (typeof messageCarrier?.message === 'string') {
    return messageCarrier.message
  }

  return fallback
}
